import { useEffect, useRef, useState } from 'react'

export const useFilterSelectOverlay = () => {
    const anchorRef = useRef(null)
    const [open, setOpen] = useState(false)
    const prevOpen = useRef(open)

    useEffect(() => {
        prevOpen.current = open
    }, [open])

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }
        setOpen(false)
    }

    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault()
            setOpen(false)
        } else if (event.key === 'Escape') {
            setOpen(false)
        }
    }

    return { handleToggle, handleClose, handleListKeyDown, anchorRef, open }
}
